export default {
  esg_dashboard: {
    title: 'Dasbor',
  },
  improvement_plans: {
    title: 'Rencana Peningkatan',
  },
  question_group_section: {
    card_title: 'Survei yang belum terjawab',
    list_header_buyer_company_name: 'Pembeli',
    list_header_question: '@:score_summary_section.list_header_question',
    list_header_deadline: 'Tenggat',
    list_header_status: 'Status',
    number_of_answered_label: 'Pertanyaan yang Sudah Dijawab',
    // number_of_answered_unit: '',
    number_of_answered: 'Sedang Berlangsung： {answered}/{total}',
    status_re_answer_request: 'Permintaan penarikan sedang diproses',
    answer: 'Jawaban',
    withdrawn: 'Ditarik',
    // no_survey_response_requests_text_1:  '',
    // contact: '',
    // no_survey_response_requests_text_2: '',
  },
  score_summary_section: {
    card_title: '@:common.scorecard.title',
    list_header_buyer_company_name: 'Pembeli',
    list_header_question: 'Survei',
    list_header_create_at: 'Tanggal terbit',
    list_header_deadline: 'Tanggal kedaluwarsa',
    list_header_status: 'Status',
    limit_one_year: 'Satu tahun sejak tanggal diterbitkan',
    esg_score: 'Skor ESG',
    esg_rating: 'Peringkat ESG',
    detail: 'Detail',
  },
  faq_section: {
    card_title: 'Tanya Jawab Umum',
    faq_why_request: {
      question:
        'Mengapa saya menerima survei melalui ASUENE ESG dari mitra bisnis?',
      answer:
        'Dalam beberapa tahun terakhir, pengadaan berkelanjutan telah menjadi tren yang signifikan, dan perusahaan diharuskan menjalankan bisnis dengan mempertimbangkan isu-isu terkait ESG di seluruh rantai pasokan mereka.Perusahaan tidak hanya perlu memeriksa dan mengungkapkan aktivitas ESG mereka sendiri, tetapi juga diharuskan untuk memeriksa dan mendorong mitra bisnisnya untuk mengambil tindakan terkait aktivitas ESG.',
    },
    faq_what_benefit: {
      question: 'Apa manfaat menjawab ASUENE ESG?',
      answer:
        'Ada tiga manfaat menjawab survei melalui ASUENE ESG.\n1) Memahami kekuatan dan kelemahan perusahaan Anda terkait ESG\n2) Membandingkan penilaian perusahaan Anda dengan perusahaan lain di industri Anda\n3) Mempromosikan aktivitas ESG perusahaan Anda dengan mengungkapkan hasil penilaian Anda',
    },
    list: 'Lihat Daftar',
  },
  contact_section: {
    card_title: 'Hubungi kami',
    description:
      'Jika Anda memiliki pertanyaan tentang survei atau cara menjawabnya, jangan ragu untuk menghubungi kami kapan saja.\nJika Anda ingin menerima dukungan yang lebih spesifik untuk meningkatkan aktivitas ESG, Anda dapat meminta dukungan dari konsultan kami.',
    inquiry: 'Hubungi kami',
  },
}
